import * as util from "../../../common/m_base/util"
import BigTemplate from '../BigTemplate.js'
import EndCardTemplate from "../EndCardTemplate"
import { override } from 'core-decorators'

import {RewardJsToggleCloseBtnShow, VideoBridgeToggleBouncesOff} from "@api";
import {getUrlParams} from "@src/common/util";

import {
    getEndScreenInfo,
} from "../../../api";
import Webview from "../../component/native/visible/Webview"
import Slot from "../Slot";
import Container from "../../component/Container"
import {getFilePathByRemoteUrl} from '@src/common/util'
import OldVideoDemo from "../rv/OldVideoDemo";
import SubplayTemplateView from "../../component/native/visible/SubplayTemplateView";
import App from "../../App";

/**
 * mintegral SDK 大模板
 */
export default class BtDemo extends BigTemplate {
    constructor(props = {}) {
        super(props)

        this.templateName = props.templateName || 'mtg_btDemo_template'


    }

    show() {
        super.show()
        console.log('im show')
    }

    adShowed(data) {
        console.log('创建SubplayTemplateView ：：：',data)
        super.adShowed(data)

        this.tplComp.setInfo({
            userId: data.param.userId,
            reward: data.param.reward,
        })

        this.tplComp.onLoad((data)=>{
            console.log('this.tplComp.onLoad',this.tplComp.id)
            //App.fullScreenShow(this.tplComp.id)
        })

        this.tplComp2.setInfo({
            userId: data.param.userId,
            reward: data.param.reward,
        })

        this.tplComp2.onLoad((data)=>{
            console.log('this.tplComp.onLoad',this.tplComp2.id)
            //App.fullScreenShow(this.tplComp.id)
        })
        console.log('initComponents OldVideoDemo2')

    }

    initComponents() {
        super.initComponents()

        const imgURL = this.campaignList[0] && this.campaignList[0].image_url
        let img = new Image()
        img.src = imgURL
        img.style.width='100%'
        img.style.height='100%'
        img.style.position='absolute'
        img.style.top='0'
        img.style.left='0'
        document.getElementById('slot_1').appendChild(img)
        document.getElementById('slot_1').addEventListener('click', ()=>{
            App.fullScreenShow(this.tplComp.id)
        }, false)

        const imgURL2 = this.campaignList[1] && this.campaignList[1].image_url
        let img2 = new Image()
        img2.src = imgURL2
        img2.style.width='100%'
        img2.style.height='100%'
        img2.style.position='absolute'
        img2.style.top='0'
        img2.style.left='0'
        //document.body.appendChild(img)
        document.getElementById('slot_2').appendChild(img2)
        document.getElementById('slot_2').addEventListener('click', ()=>{
            App.fullScreenShow(this.tplComp2.id)
        }, false)

        //this.campaign.rv.template_url = "https://hybird.rayjump.com/rv-zip-2019/1125/tpl2-blurry-06873529417cac43dfa83fe16067ae8a.zip?md5filename=06873529417cac43dfa83fe16067ae8a\u0026foldername=tpl2-blurry\u0026layout=5\u0026tpl=2\u0026wfr=1\u0026to=9999\u0026type4=true"
        this.tplComp = new SubplayTemplateView({
            campaign: this.campaignList[0],
            unitId: this.unit.id,
            unitSetting: this.unit.setting,
        })
        this.tplComp.preload().then(()=>{
            //this.tplComp.appendTo(this.container)
            console.log('do fullScreenShow --- ',this.tplComp.id)
            //App.fullScreenShow(this.tplComp.id)
        })

        this.tplComp2 = new SubplayTemplateView({
            campaign: this.campaignList[1],
            unitId: this.unit.id,
            unitSetting: this.unit.setting,
        })
        this.tplComp2.preload().then(()=>{
            //this.tplComp.appendTo(this.container)
            console.log('do fullScreenShow2 --- ',this.tplComp2.id)
            //App.fullScreenShow(this.tplComp.id)
        })

        /*const url = this.campaignList[1] && this.campaignList[1].video_url
        getFilePathByRemoteUrl(url, this.unit.id, 1).then((res)=>{

            document.getElementById('ad_video').src = res.path
            setTimeout(()=>{
                document.getElementById('ad_video').play()
                document.getElementById('ad_video').addEventListener('click', ()=>{
                    console.log('ad_video')
                    document.getElementById('ad_video').play()
                }, false)
            },0)
        })*/

        /*document.getElementById('slot_1').innerHTML = '<video id="ad_video"\n' +
            '                        src=""\n' +
            '                        autoplay' +
            '                        poster="https://diy-courseware.aixuexi.com/o_1d600jekfve91kvq1gn22qc1p1dq.mp4"\n' +
            '                        preload="auto"\n' +
            '                        loop\n' +
            '                        muted\n' +
            '                        webkit-playsinline="true"\n' +
            '                        playsinline="true"\n' +
            '                        x-webkit-airplay="allow"\n' +
            '                        x5-playsinline\n' +
            '                        x5-video-player-type="h5"\n' +
            '                        x5-video-player-fullscreen="true"\n' +
            '                        x5-video-orientation="portrait"\n' +
            '                        style="-webkit-transform: translate3d(0, 0, 0)"\n' +
            '                        >\n' +
            '                    </video>'*/

    }

    /**
     * 绑定native组件各个事件
     */
    bindNativeEvent() {
        this.container.onAppend(event=>{
            console.log('onAppend', event)
        })
        this.container.onAppendTo(event=>{
            console.log('onAppendTo', event)
        })
        this.container.onBgColorChanged(event=>{
            console.log('onBgColorChanged', event)
        })
        this.container.onLoad(event=>{
            console.log('onWebviewLoad', event)
        })
        this.container.onClicked(event=>{
            console.log('onClicked', event)
        })
        this.tplComp.onCloseBtnClicked((event)=>{
            console.log('onCloseBtnClicked', event)
            this.tplComp.removeSelf()
        })
        this.tplComp2.onCloseBtnClicked((event)=>{
            console.log('onCloseBtnClicked 2', event)
            this.tplComp2.removeSelf()
        })
    }
    /**
     * 初始化插槽
     */
    initSlots(){
        super.initSlots()
        //this.slotIn('slot_1', this.tplComp)
    }

    /**
     * 销毁组件
     */
    destory() {
        super.destory()
    }

    /**
     * 子类需要重写该方法，以判断模板的是否成功加载
     * @returns {Promise}
     */
    _isLoadFinish(){
        return Promise.all([
            super._isLoadFinish(),
        ])
    }

}